import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

export interface IWorkerGetAllRequestAction {
  data: {
    filters?: string[];
    id: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getAllRequest(
  draft: Draft<IWorkerData>,
  _: PayloadAction<IWorkerGetAllRequestAction>,
) {
  draft.getAll.config.errorMsg = '';
  draft.getAll.config.emptyMsg = '';
  draft.getAll.config.isLoading = true;
}

export default getAllRequest;
